/** Shared by the search button and keyboard submit; repeated searches refresh. */
export function submitPlayerSearch(
  text: string,
  currentTerm: string,
  disabled: boolean,
  setTerm: (term: string) => void,
  refresh: () => unknown,
): void {
  const term = text.trim()
  if (disabled || term.length < 3 || term.length > 20) return
  if (term === currentTerm) void refresh()
  else setTerm(term)
}
